export default __webpack_public_path__ + "static/media/featuresMain.de36711b.png";